// extracted by mini-css-extract-plugin
module.exports =  {"list":"list-fa_2a"};